import type { DealProviderConfig } from '@openx/components-deal/lib/utils/context/DealContext.tsx';
import type { OptionsMap } from '@openx/types/options.ts';
import { prepareMapBy } from '@openx/utils/lib/prepareMapBy.ts';
import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery.ts';

export const useExpectedAdCategoryFetch: DealProviderConfig['useExpectedAdCategoryFetch'] = () => {
  const { data: { optionsByPath = [] } = {}, loading } = useOptionsByPathQuery({
    variables: {
      path: 'deal.custom_pricing_ad_category',
    },
  });

  const mapById = useMemo(() => {
    return prepareMapBy(optionsByPath, 'id');
  }, [optionsByPath]);

  return {
    expectedAdCategoryMap: mapById as OptionsMap,
    isExpectedAdCategoryLoading: loading,
  };
};
